<template>
    <div class="mt-3">
        <b-row class="mb-3">
            <b-col md="12" v-show="isLoading != 1">
                <div v-show="isLoading == 0">
                    <div class="d-flex justify-content-center mt-4">
                        <b-spinner label="Loading..." type="grow" style="width: 5rem; height: 5rem"></b-spinner>
                    </div>
                    <div class="d-flex justify-content-center">
                        Fetching data, please wait...
                    </div>
                </div>
                <b-row class="mt-4" v-show="isLoading == 2">
                    <b-col offset-sm="3" sm="6">
                        <b-card style="text-align: center">
                            <h4><strong>Error</strong></h4>
                            Unable to retrieve calculation data.<br />
                            Please wait a moment, and retry.<br />
                            <b-btn class="mt-3" variant="primary" @click="getCalculation">Retry</b-btn>
                        </b-card>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="2" v-show="isLoading == 1">
                <b-card no-body style="text-align: center">
                    <h4 class="strong mt-4">{{ general.name }}</h4>
                    <div class="mb-4">
                        <b-form-text>{{ general.method }}</b-form-text>
                        <b-form-text style="margin-top: 0">{{ general.instrument }}</b-form-text>
                        <b-badge variant="success">{{ general.unit == "ft" ? "Feet (ft)" : "Meter (m)" }}</b-badge>
                    </div>
                    <b-form-radio-group
                        class="navchild squared"
                        id="btn-radios-1"
                        v-model="selected"
                        :options="options"
                        buttons stacked
                        button-variant="dark"
                        name="radios-btn-default"
                    ></b-form-radio-group>
                </b-card>
                <b-card no-body class="mt-4">
                    <b-button squared variant="dark" v-b-toggle.term>Terminologies</b-button>
                    <b-collapse id="term">
                        <b-row style="max-height: 150px; overflow-y: auto; padding: 10px">
                            <b-col sm="12">
                                <div v-for="term in terminologies" v-bind:key="term[0]">
                                    <strong>{{ term[0] }}</strong><br />
                                    {{ term[1] }}
                                    <hr class="margined" />
                                </div>
                            </b-col>
                        </b-row>
                    </b-collapse>
                </b-card>
                <!-- <b-card no-body class="mt-4">
                    <b-button squared variant="dark" v-b-toggle.calculator>Unit Converter</b-button>
                    <b-collapse id="calculator">
                        <b-row style="padding: 10px">
                            <b-col sm="12">
                                <b-form-text>Feet</b-form-text>
                                <b-input size="sm" type="number" v-model="foot" />
                                <b-form-text class="mt-2">Meter</b-form-text>
                                <b-input size="sm" type="number" v-model="meter" />

                            </b-col>
                        </b-row>
                    </b-collapse>
                </b-card> -->
            </b-col>
            <b-col md="10">
                <!-- <b-card no-body v-show="isLoading == 1">
                    <b-card-body style="padding: 0">
                        <div class="navbar">
                            <b-form-radio-group
                                class="navchild squared"
                                id="btn-radios-1"
                                v-model="selected"
                                :options="options"
                                buttons
                                button-variant="light"
                                name="radios-btn-default"
                            ></b-form-radio-group>
                        </div>
                    </b-card-body>
                </b-card> -->
                <transition name="fade" mode="out-in">
                    <router-view />
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: "ipr-input",
    data() {
        return {
            selected: "Overview",
            options: [
                { text: "Overview", value: "overview" },
                { text: "Data Input", value: "data-input" },
                { text: "IPR Curve", value: "ipr-curve", disabled: true },
                { text: "Pump Selection", value: "pump-selection", disabled: true },
                { text: "Equipment Selection", value: "equipment-selection", disabled: true },
                { text: "Trajectory", value: "trajectory" },
                { text: "String Diagram", value: "string-diagram" }            
            ],

            general: {
                name: "",
                method: "",
                instrument: "",
                unit: ""
            },

            isLoading: 0,

            terminologies: [
                ["P. Casing", "Casing Pressure"],
                ["SBHP", "Static Bottom Hole Pressure"],
                ["FBHP", "Flowing Bottom Hole Pressure"]
            ]
        }
    },
    computed: {

        // foot() {
        //     return this.meter * 3.281
        // },

        // meter() {
        //     return this.foot / 3.281
        // }

    },
    watch: {
        selected: function(newValue) {
            // let route = newValue.replace(" ", "-").toLowerCase()
            let route = newValue
            this.$router.push("/input/" + route)
        }
    },
    methods: {

        getCalculation() {

            // Reset core
            this.$core.general = {}
            this.$core.input = {}
            this.$core.dirtyInput = {}
            this.$core.output = {}
            this.$core.pump = {}
            this.$core.equipment = {}
            this.$core.trajectory = {}
            this.$core.attachment.ipr = false
            this.$core.attachment.pump = false
            this.$core.idConstraint = 0

            let url = "/calc/complete/" + this.$core.id

            this.isLoading = 0
            this.$axios.get(url).then(response => {
            
                let res = response.data
                if(res.message == "OK") {

                    let data = res.data
                    this.general = data.general

                    this.$core.general = data.general
                    if(data.input != null) {
                        this.$core.dirtyInput = data.input
                        this.$core.input = JSON.parse(JSON.stringify(data.input))
                        this.$core.output = data.output
                        this.$core.pump.input = data.pumpInput
                        this.$core.pump.graph = data.pumpGraph
                        this.$core.equipment = data.equipment
                        this.$core.trajectory = data.trajectory
                        this.$core.attachment.ipr = data.attachment.ipr
                        this.$core.attachment.pump = data.attachment.pump
                    }

                    // ID Constraint
                    if("linerOD" in this.$core.input) {

                        let inp = this.$core.input

                        if(inp.linerOD != null && inp.topLiner != null && inp.psd > inp.topLiner) {
                            this.$core.idConstraint = inp.linerOD
                        }
                        else {
                            this.$core.idConstraint = inp.caseId
                        }

                    }

                    // Enable sections that have been saved
                    if(this.$core.output != null && "midPerfo" in this.$core.output) {
                        this.options[2].disabled = false
                        this.options[3].disabled = false
                    }

                    if(this.$core.pump.graph != null && "graph" in this.$core.pump.graph) {
                        this.options[4].disabled = false
                    }

                    this.isLoading = 1
                    this.$router.replace("/input/overview")

                }
                else {
                    this.isLoading = 2
                }

            })

        }

    },
    created: function() {

        // Listeners
        this.$router.app.$on('changeTab', newTab => {
            this.selected = newTab
        })

        this.$router.app.$on('enableTab', index => {
            this.options[index].disabled = false
        })

        this.$router.app.$on('disableTab', index => {
            this.options[index].disabled = true
        })

        // Get existing calculation data
        if(this.$core.id != null && this.$core.id != 0) {
            this.getCalculation()
        }
        else {
            this.$router.push('/dashboard')
        }

    },
    // beforeRouteLeave(to, from, next) {

    //     if(confirm("Leave this well calculation? Any unsaved inputs will be discarded!")) {
    //         next()
    //     }

    // }
}
</script>

<style scoped>
    .navbar {
        display: flex;
        flex-wrap: wrap;
        padding: 0px;
    }

    .fixedContainer {
        position: fixed;
        padding: 2em;
        left: 50%;
        top: 0%;
        transform: translateX(-50%);
    }

    .navchild {
        flex: 1 1 auto;
        text-align: center;
    }

    .squared >>> .btn {
        text-align: left !important;
        border-radius: 0px;
    }

    .squared >>> .active {
        font-weight: 800;
    }

    .margined {
        margin-top: 8px;
        margin-bottom: 8px;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>